import type { ReactNode } from 'react';

type DepotGridPanelProps = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
};

type DepotEmptyRowProps = {
  colSpan: number;
  children: ReactNode;
};

export function DepotGridPanel({ title, subtitle, action, children }: DepotGridPanelProps) {
  return (
    <section className="overflow-hidden rounded-lg border bg-background">
      <div className="flex flex-wrap items-start justify-between gap-3 border-b bg-muted/20 px-3 py-2.5">
        <div>
          <h3 className="text-sm font-semibold">{title}</h3>
          {subtitle ? <p className="text-xs text-muted-foreground">{subtitle}</p> : null}
        </div>
        {action ? <div className="flex items-center gap-2">{action}</div> : null}
      </div>
      <div className="overflow-x-auto">{children}</div>
    </section>
  );
}

export function DepotEmptyRow({ colSpan, children }: DepotEmptyRowProps) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-3 py-8 text-center text-sm text-muted-foreground">
        {children}
      </td>
    </tr>
  );
}

export const depotTableClassName = 'w-full min-w-[960px] text-sm';
export const depotTableHeadClassName = 'bg-muted/30 text-xs uppercase text-muted-foreground';
export const depotThClassName = 'px-3 py-2 text-left font-semibold';
export const depotTdClassName = 'px-3 py-2 align-top';
